export default "__VITE_ASSET__CrqwPH$o__"